import React from "react";
import ProjectCard from "../utils/ProjectCard";
import Heading from "../utils/Heading";
import "../styles/projectcard.css";
import projects from "../constants/projectdata";




function ProjectCardData(project: any) {
  return (
    <ProjectCard
    images={project.images} 
      name={project.name}
      description={project.description}
      link={project.link}
    />
  );
}

const Projects = () => {
  return (
    <div className="container wrapper">
      <div className="column" id="projects">
        <Heading heading={"PORTFOLIO"} />
        {projects.map((project: any) => (
          <ProjectCardData {...project} key={project.id} /> 
        ))}
      </div>
    </div>
  );
};

export default Projects;
